export const TEXTS_SEGURIDAD = {
  es_ES: new Map([
    ['download', 'Descargar'],
    ['reset', 'Restablecer'],
    ['intervenciones_totales', 'INTERVENCIONES TOTALES'],
    ['intervenciones_tipo', 'INTERVENCIONES POR TIPO'],
    ['intervenciones', 'intervenciones'],
    ['tipologia_nivel', 'TIPOLOGÍA NIVEL'],
    ['top_5', 'TOP 5'],
    ['tipologia_seguridad', 'INTERVENCIONES SEGURIDAD CIUDADANA'],
    ['barrio', 'POR BARRIO'],
    ['evolucion_horaria', 'EVOLUCIÓN HORARIA'],
    ['evolucion_diaria', 'EVOLUCIÓN DIARIA'],
    ['evolucion_mensual', 'EVOLUCIÓN MENSUAL'],
    ['evolucion_anual', 'EVOLUCIÓN ANUAL'],
  ]),
  ca_ES: new Map([
    ['download', 'Desar'],
    ['reset', 'Restablir'],
    ['intervenciones_totales', 'INTERVENCIONS TOTALS'],
    ['intervenciones_tipo', 'INTERVENCIONS PER TIPUS'],
    ['intervenciones', 'intervencions'],
    ['tipologia_nivel', 'TIPOLOGIA NIVELL'],
    ['top_5', 'TOP 5'],
    ['tipologia_seguridad', 'INTERVENCIONS SEGURETAT CIUTADANA'],
    ['barrio', 'PER BARRI'],
    ['evolucion_horaria', 'EVOLUCIÓ HORÀRIA'],
    ['evolucion_diaria', 'EVOLUCIÓ DIÀRIA'],
    ['evolucion_mensual', 'EVOLUCIÓ MENSUAL'],
    ['evolucion_anual', 'EVOLUCIÓ ANUAL'],
  ]),
};
